"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _ = require("../../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const MemoizedProgress = /*#__PURE__*/_react.default.memo(_.Progress);

const ProgressItem = props => {
  const {
    activationStatus,
    progressStatus,
    ...otherProps
  } = props;

  const getProgressValue = () => {
    switch (activationStatus) {
      case 'empty':
        return 0;

      case 'inProgress':
        return progressStatus;

      case 'filled':
        return 100;

      default:
        return 0;
    }
  };

  return (0, _pragma.createFelaElement)(MemoizedProgress, _extends({
    value: getProgressValue(),
    variant: "primary",
    progressColor: "white",
    progressBg: "rgba(255, 255, 255, 0.5)",
    borderRadius: "0"
  }, otherProps));
};

var _default = ProgressItem;
exports.default = _default;
//# sourceMappingURL=ProgressItem.js.map